import req from './req'

// 查看每日销售概况
export function getIndexOverview (params) {
  return req.get('/index/overview', params)
}

// 销售额月度分析
export function getIncomeAnalysis (params) {
  return req.get('/index/income-analysis', params)
}

// 客户月度分析
export function getCustomerAnalysis (params) {
  return req.get('/index/customer-analysis', params)
}
